import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  static VIEWS ="views"
  static TOKEN ="token"
  static APP_INFORMATION ="app_information"
  /**
   * Guarda un valor en el localStorage con un tiempo de expiración.
   * @param key La clave para almacenar el valor.
   * @param value El valor a guardar.
   * @param ttl Tiempo de vida en milisegundos.
   */
  set(key: string, value: any, ttl: number): void {
    const expireTime = Date.now() + ttl;
    const item = {
      value: value,
      expireTime: expireTime
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  /**
   * Obtiene un valor del localStorage.
   * Si el valor ha expirado, lo elimina y devuelve `null`.
   * @param key La clave del valor a recuperar.
   * @returns El valor almacenado o `null` si ha expirado o no existe.
   */
  get(key: string): any {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    if (Date.now() > item.expireTime) {
      localStorage.removeItem(key); // Eliminar si ha expirado
      return null;
    }

    return item.value;
  }

  /**
   * Elimina un valor del localStorage.
   * @param key La clave del valor a eliminar.
   */
  remove(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Limpia todo el contenido del localStorage.
   */
  clear(): void {
    localStorage.clear();
  }
}
